<script setup lang="ts">
import StfBulletPoint from '@/ui/list/StfBulletPoint.vue';
import ExternalLink from '@/components/common/ExternalLink.vue';
import useDomain from '@/composables/domainDependable';
import {computed} from 'vue';
import {storeToRefs} from 'pinia';
import {useTrademarkStore} from '@/store/mark';
import {useTermOfUseStore} from '@/store/terms-of-use';
import StfCheckbox from '@/ui/checkbox/StfCheckbox.vue';
import {useApplicationStore} from '@/store/application';

const domain = useDomain();
const termOfUseStore = useTermOfUseStore();
const { hasValidation } = storeToRefs(useApplicationStore());
const {isTermOfUseStepValid, isConfirm } = storeToRefs(termOfUseStore);
const {trademarkWord} = storeToRefs(useTrademarkStore());

const termsOfUseLinks = computed(() => {
    const baseUrl = domain.website;

    return `${baseUrl}${domain.termOfUseUrl}`;
});

const isLowerCaseWord = computed(() => {
    if (trademarkWord.value) {
        if (trademarkWord.value !== trademarkWord.value.toUpperCase()) {
            return true;
        }
    }

    return false;
});
</script>

<template>
    <StfCard :success="isTermOfUseStepValid" :error="hasValidation && !isTermOfUseStepValid">
        <template #title>
            <stf-heading>
                <StfRow vcenter>
                    <StfCol narrow>
                        <StfCheckbox :model-value="isConfirm" @update:modelValue="(value) => termOfUseStore.setTermOfUseConfirmation(value)"></StfCheckbox>
                    </StfCol>
                    <StfCol>I confirm that:</StfCol>
                </StfRow>
            </stf-heading>
        </template>
        <template #content>
            <StfBulletPoint class="stf-info-text">
                <li class="my-1">The applicant intends to use, and is entitled to own, the trademark</li>
                <li class="my-1">The TM Office will not let me change the trademark or goods and services after it has been submitted</li>
                <li class="my-1">I have read and agree to the <external-link :href="termsOfUseLinks">Terms of Use</external-link></li>
                <li class="my-1">I consent to receiving emails regarding my ongoing application</li>
                <li class="my-1">I am entitled to submit this application on behalf of the Trademark Owner</li>
                <li v-if="isLowerCaseWord" class="my-1">I want to use lowercase words for my application even though though the protection will be less strong</li>
            </StfBulletPoint>
        </template>
    </StfCard>
</template>

<style scoped lang="scss">

</style>
